import React, { useCallback, useState } from 'react';
import IconButton from 'components/IconButton';
import { InputAdornment } from 'components/InputBase';
import { TextFieldProps } from 'components/TextField';
import TextField from 'components/TextField/TextField';
import { Lock, Visibility, VisibilityOff } from 'icons';

export interface PasswordFieldProps extends TextFieldProps {}

/**
 * A wrapper around `TextField` to create a reusable password input
 */
export const PasswordField = React.forwardRef<
  HTMLInputElement,
  PasswordFieldProps
>(({ 'aria-label': ariaLabel = 'password field', ...props }, ref) => {
  const [inputType, setInputType] = useState<'text' | 'password'>('password');

  const handleToggleVisibility = useCallback(() => {
    setInputType((currentType) =>
      currentType === 'password' ? 'text' : 'password',
    );
  }, []);

  return (
    <TextField
      aria-label={ariaLabel}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onPress={handleToggleVisibility}
            variant="adornment"
            style={{ height: 16 }}
          >
            {inputType === 'password' ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      }
      startAdornment={
        <InputAdornment position="start">
          <Lock />
        </InputAdornment>
      }
      placeholder="Password"
      ref={ref}
      type={inputType}
      {...props}
    />
  );
});

export default PasswordField;
